import Component from '../abstracts/Component';
import TrackingComponent from './TrackingComponent';

export default class NotifyMeComponent extends Component {

  get COMPONENTNAME() {
    return 'NotifyMeComponent';
  }

  get SELECTORS() {
    return {
      notifySubmitBtn: '[data-js-notifyme-submit].--desktop',
      notifySubmitBtnMobile: '[data-js-notifyme-submit].--mobile',
      notifyForm: '[data-js-form]',
      notifyConfirm: '[data-js-confirm]',
      notifyConfirmText: '[data-js-confirm-text]',
      notifyInput: 'input[type="email"]',
      sizeSelected: '#jsSizeSelectedInput',
      productCode: '#productCode',
      errorMsg: '[data-js-error]',
      formWrapper: '[data-js-form-wrapper]'
    };
  }

  constructor(compEl) {
    super(compEl);
    this.TrackingComponent = new TrackingComponent();
  }

  readDOM() {
    return {
      notifySubmitBtn: document.querySelector(this.SELECTORS.notifySubmitBtn),
      notifySubmitBtnMobile: document.querySelector(this.SELECTORS.notifySubmitBtnMobile),
      notifyForm: this.$component.querySelector(this.SELECTORS.notifyForm),
      notifyConfirm: this.$component.querySelector(this.SELECTORS.notifyConfirm),
      notifyConfirmText: this.$component.querySelector(this.SELECTORS.notifyConfirmText),
      sizeSelected: this.$component.querySelector(this.SELECTORS.sizeSelected),
      productCode: this.$component.querySelector(this.SELECTORS.productCode),
      errorMsg: this.$component.querySelector(this.SELECTORS.errorMsg),
      formWrapper: this.$component.querySelector(this.SELECTORS.formWrapper),
    };
  }

  // FETCH //
  submitForm(notifyForm, notifySubmitBtn, notifyConfirm, notifyMeFormEmail, sizeSelector = null) {
    const url = notifyForm.action;
    const data = new FormData(notifyForm);
    const notifyInput = notifyForm.querySelector(this.SELECTORS.notifyInput);

    this.toggleSubmitButtonLoading(notifySubmitBtn, true);

    fetch(url, {
      method: 'POST',
      body: data
    })
      .then(response => {
        if (response.ok) {
          return response.text().then(text => {
            this.toggleError(notifyForm, notifyInput, true, data.get("size"), sizeSelector);
            notifyConfirm.querySelector(this.SELECTORS.notifyConfirmText).innerHTML = text;
            notifyConfirm.classList.remove("hidden");
            notifyForm.classList.add("hidden");
            notifySubmitBtn.classList.add("hidden");
            this.dom?.formWrapper?.classList.add("hidden");
            if (notifyMeFormEmail) {
              notifyMeFormEmail.classList.add("hidden");
            }
            this.toggleSubmitButtonLoading(notifySubmitBtn);
            const productCode = data.get("productCode");
            if (productCode) {
              this.TrackingComponent.actions.notifyMe(productCode);
            }
          })
        } else {
          this.toggleError(notifyForm, notifyInput, false, data.get("size"), sizeSelector);
          this.toggleSubmitButtonLoading(notifySubmitBtn);
        }
      })
      .catch((error) => {
        this.warn(error);
        this.toggleError(notifyForm, notifyInput, false, data.get("size"), sizeSelector);
        this.toggleSubmitButtonLoading(notifySubmitBtn);
      });
  }

  // MAIN EVENTS
  bindEvents() {
    // open form
    this.$on(this.$customEvents.PRODUCT_EVENTS.notifyme, ({event, payload}) => {
      this.$component.classList.remove("hidden");
      this.dom.notifySubmitBtn.classList.remove("hidden");
      if (window.matchMedia('(max-width: 768px)').matches) {
        this.dom.notifySubmitBtnMobile.classList.remove("hidden");
      }
      // reset form for new request, avoid reset if no size was selected
      this.dom.notifyConfirm.classList.add("hidden");
      this.dom.notifyForm.classList.remove("hidden");
      this.dom.formWrapper.classList.remove("hidden");

      const emailInput = this.dom.notifyForm.querySelector('input[type="email"]');
      const formProductCode = this.dom.notifyForm.querySelector('input#productCode');
      if (formProductCode && emailInput) {
        if (formProductCode.value.length > 13)
        {
          emailInput.value = '';
        }
      }

      // don't enable button for event on page load (empty size)
      if (!payload.unavailable) {
        if (window.matchMedia('(max-width: 768px)').matches) {
          this.dom.notifySubmitBtnMobile.disabled = false;
        } else {
          this.dom.notifySubmitBtn.disabled = false;
        }
      }
    });
    // hide form
    this.$on(this.$customEvents.PRODUCT_EVENTS.notifymeclose, ({event, payload}) => {
      this.$component.classList.add("hidden");
      this.dom.notifySubmitBtn.classList.add("hidden");
      this.dom.notifySubmitBtn.disabled = true;
      if (window.matchMedia('(max-width: 768px)').matches) {
        this.dom.notifySubmitBtnMobile.classList.add("hidden");
        this.dom.notifySubmitBtnMobile.disabled = true;
      }
    });

    //handle size selection
    this.$on(this.$customEvents.PRODUCT_EVENTS.sizechanged, ({event, payload}) => {
      this.dom.productCode.value = payload.productCode;
      this.dom.sizeSelected.value = payload.productCode;
    });

    //handle mobile pdp
    if(this.dom.notifySubmitBtnMobile) {
      this.dom.notifySubmitBtnMobile.addEventListener("click", (event) =>{
        event.preventDefault();
        event.stopPropagation();
        this.$component.scrollIntoView({ block: "center", inline: 'center', behavior: "smooth" });
        if (this.dom.notifySubmitBtnMobile.disabled !== true) {
          this.submitForm(this.dom.notifyForm, this.dom.notifySubmitBtnMobile, this.dom.notifyConfirm);
        }
      });
    }
  }

  // submit form
  bindSubmit() {
    // if user press enter key on form visible
    if (this.dom.notifyForm) {
      this.dom.notifyForm.addEventListener("submit", (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (this.dom.notifySubmitBtn.disabled !== true) {
          this.submitForm(this.dom.notifyForm, this.dom.notifySubmitBtn, this.dom.notifyConfirm);
        }
      });
    }
    // if user presses submit btn
    if (this.dom.notifySubmitBtn) {
      this.dom.notifySubmitBtn.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.dom.notifyForm.requestSubmit();
      });
    }
  }

  toggleSubmitButtonLoading(notifyMeSubmitButton, loading = false) {
    if (notifyMeSubmitButton) {
      if (loading) {
        notifyMeSubmitButton.classList.add('--loading');
      } else {
        notifyMeSubmitButton.classList.remove('--loading');
      }
    }
  }

  toggleError(notifyForm, notifyInput, hideError = false, size = null, sizeSelector = null) {
    const errorMsg = notifyForm.querySelector(this.SELECTORS.errorMsg);
    if (hideError) {
      notifyForm ? notifyForm.querySelector(this.SELECTORS.errorMsg).classList.add("hidden") : '';
      notifyInput ? notifyInput.classList.remove('error') : '';
      sizeSelector ? sizeSelector.classList.remove('error') : '';
    } else {
      if (!size || size == '') {
        if (sizeSelector) {
          // case for wishlist
          sizeSelector.classList.add('error');
          errorMsg.innerHTML = '';
        } else {
          errorMsg.innerHTML = errorMsg.dataset.nosizeSelected;
        }
      } else {
        errorMsg.innerHTML = errorMsg.dataset.jsError;
      }
      notifyForm ? notifyForm.querySelector(this.SELECTORS.errorMsg).classList.remove("hidden") : '';
      notifyInput && (size && size !== '') ? notifyInput.classList.add('error') : '';
    }
  }

  render() {
    this.log("Rendering...");
    this.dom = this.readDOM();
    this.bindEvents();
    this.bindSubmit();
  }
}
